import {DEFAULT_GRID_CONFIG} from "../../../constants/gridConfig";

const gridConfigReducer = (state = DEFAULT_GRID_CONFIG, action) => {
  switch (action.type) {
    case 'LOAD_STATE':
      return action.payload.loadedState.gridConfig || state;
    default:
      return state;
  }
};

export default gridConfigReducer;
